import { postData } from '@client/utils/db.ts'

export type TLogLevel = 'info' | 'error' | 'debug'

export type TLog = {
    level: TLogLevel
    message: string
    metadata?: any
}

export default class ServerLog {
    constructor() {}

    public async log(logToSend: TLog) {
        return await postData('/log', { log: logToSend })
    }
}
